import { createContext } from 'react';
var defaultContext = {
    patient: {
        patientId: -1,
        name: '',
    },
    practice: {
        name: '',
        customerId: -1,
        practiceGuid: '',
    },
    user: {
        userGuid: '',
    },
    error: null,
    setError: function () { },
    isProcessingTransaction: false,
    setIsProcessingTransaction: function () { },
    saveCardState: {
        isCheckedSaveCard: false,
        cardDescription: '',
        cardNickname: '',
    },
    setSaveCardState: function () { },
    isNewCardFormOpen: false,
    setIsNewCardFormOpen: function () { },
    cards: [],
    selectedCard: null,
    setSelectedCard: function (card) { },
    isCardListFetching: true,
    isUsingTerminalPayOption: false,
    setIsUsingTerminalPayOption: function (enabled) { },
    selectedTerminal: null,
    setSelectedTerminal: function (terminal) { },
    deleteCard: function (cardId) { },
};
var CardDetailsContext = createContext(defaultContext);
export default CardDetailsContext;
